/* DISCORD ACTIVITY CLIENT - Handles Websocket communication with Activity Server */ 
import { getQueryParam, sendMessageToChild } from './gamemanager'
import { UserJoinMessage, UserLeaveMessage, WelcomeMessage, NewLeaderMessage, ShareLinkMessage, ReadyStatusMessage, JoinLeftRoomMessage, InstancePrivacyStatusMessage } from '@shared/messages';
import { ActivityInstance, Participant, ParticipantInfo} from '@shared/interfaces';
//import { username } from './utils/initializeSdk';
import * as gameManager from './gamemanager'
import { discordSdk } from './utils/initializeSdk';
import { getModeList } from './utils/gamemodes';
import { Warmerise_Custom_Assets, Warmerise_Custom_Asset_Files } from './utils/dbtables'

let socket: WebSocket | null = null;

//let pingInterval: ReturnType<typeof setInterval> | null = null;

let activityInstance:ActivityInstance;

export let myParticipantId:string;
export let myParticipantName:string;
export let globalGameVersion:string = '1.0.0';

//UI Panel
let panel_container:HTMLElement;
let player_grid:HTMLElement;
let leader_name:HTMLElement;
let unready_button:HTMLElement;
let private_squad_setting:HTMLElement;
let is_private:HTMLInputElement;
let player_count:HTMLElement;
let map_name:HTMLElement;
let game_mode:HTMLElement;
let countdown:HTMLElement;
let more_info:HTMLElement;
let info_timer:HTMLElement;
let activityMessages:HTMLElement;
//let room_capacity:string | null = "";
let countdown_timer:any = null;
let shareLinkTmp:string = "";
let baseIframeUrlTmp:string = "";
let invite_section:HTMLElement;
let invite_button:HTMLElement;
let invite_message:HTMLElement;
let sso_buttons_wrapper:HTMLElement;

let leaderInfoMessage:string = 'TO START, OPEN ROOM LIST >> JOIN EXISTING ROOM or CREATE NEW ROOM';
let userInfoMessage:string = 'WAIT FOR THE ACTIVITY LEADER TO CREATE A NEW ROOM';

let lastInviteClick:number = 0;

let isReady = true;
let isReconnecting = false;

let lastMessage:any;
let invitePermissionEnabled:boolean = false;

//let originalInstanceId:string;
let currentInstanceId:string;

let isProxy:boolean;

//Game mode selection
let gamemode_panel_container:HTMLElement;
let gamemode_panel_close:HTMLElement;
let gamemode_grid:HTMLElement;
//

//EXPORTS
export function sendMessageToServer(message:any) {
    if (socket && socket.readyState === WebSocket.OPEN) {
        var json = JSON.stringify(message);

        console.log('Sending message to server: '+ json);
        socket.send(json);
    }else{
        console.log('WebSocket is not connecting, storing message to backlog:', message);
        lastMessage = message;
    }
}

export function checkProxy():boolean{
    return window.location.href.indexOf(".discordsays.com/") !== -1;
}

export async function joinSession(instanceId: string, accessToken: string) {
    //Custom game mode selection UI
    gamemode_panel_container = document.getElementById("gameModePanel") as HTMLElement;
    gamemode_panel_close = document.getElementById("gameModeListClose") as HTMLElement;
    gamemode_grid = document.getElementById("gamemode_grid") as HTMLElement;
    gamemode_panel_close.onclick = function(){
        gamemode_panel_container.style.display = "none";
    };
    //Player list UI
    panel_container = document.getElementById("panel_container") as HTMLElement;
    invite_section = document.getElementById("invite_section") as HTMLElement;
    invite_button = invite_section.querySelector(".invite-btn") as HTMLElement;
    invite_message = invite_section.querySelector(".invite-reward") as HTMLElement;
    invitePermissionEnabled = await gameManager.invitePermissionEnabled();
    if(invite_button){
        if(invitePermissionEnabled){
            invite_button.onclick = function(){
                if(Date.now() - lastInviteClick <= 100) return;
                lastInviteClick = Date.now();
                //console.log("Invite button pressed.");
                if(gameManager.invite_opened){
                    gameManager.openInviteDialog();
                }else{
                    sendMessageToChild({"type":"open-invite"});
                }
            };
        }else{
            invite_message.style.display = "none";
            invite_button.textContent = "Leave Public Squad";
            invite_button.onclick = function(){
                //currentInstanceId = originalInstanceId;
                if(socket){
                    socket.onclose = function(){ 
                        invite_button.style.display = "none";
                        panel_container.style.display = "none";
                        window.isLeader = true;
                        gameManager.triggerJoinGame("isLeader", true);
                    };
                    if(socket.readyState === WebSocket.OPEN){
                        socket.close();
                    }
                    stopCountdownTimer();
                }
            };
        }
    }
    invite_section.style.display = "none";
    unready_button = document.getElementById("unready_button") as HTMLElement;
    if(unready_button){
        unready_button.onclick = function(){
            const data:ReadyStatusMessage = {'type':'ready-status', isready:!isReady, userid:myParticipantId};
            sendMessageToServer(data);
        };
    }
    private_squad_setting = document.getElementById("private_squad_setting") as HTMLElement;
    is_private = document.getElementById("is_private") as HTMLInputElement;
    is_private.onchange = function(){
        const data:InstancePrivacyStatusMessage = {'type':'set-private', isprivate:is_private.checked};
        sendMessageToServer(data);
        activityInstance.isprivate = data.isprivate;
    };
    player_count = document.getElementById("player_count") as HTMLElement;
    if(player_count){
        player_count.textContent = '';
    }
    map_name = document.getElementById("map_name") as HTMLElement;
    if(map_name){
        map_name.textContent = '';
    }
    game_mode = document.getElementById("game_mode") as HTMLElement;
    if(game_mode){
        game_mode.textContent = '';
    }
    countdown = document.getElementById("countdown") as HTMLElement;
    if(countdown){
        countdown.textContent = '';
    }
    more_info = document.getElementById("more_info") as HTMLElement;
    if(more_info){
        more_info.textContent = userInfoMessage;
    }
    info_timer = document.getElementById("info_timer") as HTMLElement;
    if(info_timer){
        info_timer.textContent = '';
    }
    const panel_off:HTMLElement = document.getElementById("panel_off") as HTMLElement;
    const panel_on:HTMLElement = document.getElementById("panel_on") as HTMLElement;
    player_grid = document.getElementById("player_grid") as HTMLElement;
    if(player_grid){
        player_grid.innerHTML = '';
    }
    activityMessages = document.getElementById("message_panel_container") as HTMLElement;
    leader_name = document.getElementById("leader_name") as HTMLElement;
    if(panel_off && panel_on){
        const panel_off_hamburger:HTMLElement = panel_off.querySelector(".hamburger") as HTMLElement;
        const panel_on_hamburger:HTMLElement = panel_on.querySelector(".hamburger") as HTMLElement;
        panel_off.style.display = "none";
        if(panel_off_hamburger){
            panel_off_hamburger.onclick = function(){
                panel_off.style.display = "none";
                panel_on.removeAttribute("style");
            };
        }
        if(panel_on_hamburger){
            panel_on_hamburger.onclick = function(){
                panel_on.style.display = "none";
                panel_off.removeAttribute("style");
            };
        }
    }

    isProxy = checkProxy();
    
    //Login on site (Sets Session Cookies)
    /*await fetch((isProxy ? '/.proxy' : 'https://warmerise.com') + `/sso/discord?token=${accessToken}`, { method: 'GET', credentials: 'include' }).then(response => response.text()).catch(() => {});
    if(sessionStorage.getItem("discord_auth") === null){
        sessionStorage.setItem("discord_auth", "1");
        await fetch((isProxy ? '/.proxy/warmerise' : 'https://warmerise.com') + '/rest-api/auth?output=base64', { method: 'GET', credentials: 'include' }).then(response => response.text()).catch(() => {});
        //window.location.href = window.location.href + "&t=" + new Date().getTime();
        throw new Error('Stopping parent execution');
    }*/
    sso_buttons_wrapper = document.getElementById("sso_buttons_wrapper") as HTMLElement;
    /*for(let i = 0; i < (sessionStorage.getItem("discord_auth") === null ? 2 : 1); i++){
        if(i === 1){
            sessionStorage.setItem("discord_auth", "1");
        }*/
    await ssoFetchData(instanceId, accessToken, null, true);
    //}
    //
}

async function continueJoinSession(instanceId: string, accessToken: string) {

    const accessTokenStr:string = JSON.parse(accessToken).access_token;

    if(sso_buttons_wrapper){
        sso_buttons_wrapper.style.display = "none";
    }

    if(!checkProxy()){
        const notification_container:HTMLElement = document.getElementById("notification_container") as HTMLElement;
        notification_container.removeAttribute("style");
        notification_container.style.opacity = "0";
        notification_container.onclick = function(){ window.open("https://discord.gg/bG7y9ZfpEB", "_blank"); };
        setTimeout(function(){ notification_container.style.opacity = "1" }, 1);
    }

    //Get global game version
    const CLIENT_ID = process.env.CLIENT_ID??"1258530387605327983";
    await fetch((isProxy ? '/.proxy' : 'https://warmerise.com') + '/Warmerise/' + getQueryParam('build_channel', CLIENT_ID === '1258530387605327983' ? 'ProductionWebGL' : 'StagingWebGL', ['StagingWebGL', 'ProductionWebGL']) + '/GlobalVersion.txt?v=' + new Date().getTime())
        .then(response => response.text())  // Read the response as text
        .then(data => {
            globalGameVersion = data;
        })
        .catch(error => console.error('Error fetching file:', error));

    //originalInstanceId = instanceId;
    currentInstanceId = instanceId;

    let connectAttempts = 0;

    function connect(accessToken: string){
        if(connectAttempts > 30) return;

        const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
        const host = window.location.host;
        const wsUrl = `${protocol}://${host}` + (isProxy ? '/.proxy' : '') + `/websocket?instanceId=${currentInstanceId}&accessToken=${accessToken}` + (isReconnecting ? '&isReconnecting=1' : '') + (!invitePermissionEnabled ? '&joinExisting=1' : '');
        
        console.log('WebSocket connecting');

        socket = new WebSocket(wsUrl);

        socket.onopen = () => {
            console.log('WebSocket connection opened');

            // Start sending ping messages
            console.log('Setting ping interval');
            /*setInterval(() => {
                console.log('Ping interval function called');
                if (socket && socket.readyState === WebSocket.OPEN) {
                    socket.send(JSON.stringify({ type: 'ping' }));
                    console.log('ping');
                } else {
                    console.log('WebSocket is not open');
                }
            }, 30000);*/ // Send a ping every 30 seconds
            requestAnimationFrame(ping);
            connectAttempts = 0;

            setTimeout(() => {
                if(lastMessage){
                    sendMessageToServer(lastMessage);
                    lastMessage = null;
                }
            }, 1000);

            //Simulate web socket being closed in 30 seconds
            //setTimeout(() => {socket?.close();}, 30000);
        };

        socket.onmessage = socketMessageHandler;

        socket.onclose = (event) => {
            console.log('WebSocket connection closed: ' + event.reason);
            /*if (pingInterval) {
                clearInterval(pingInterval);
            }*/
            //Retry connection in 1 second
            setTimeout(() => {isReconnecting = true; connect(accessTokenStr);}, 1000);
        };

        socket.onerror = (error) => {
            console.error('WebSocket error:', error);
            if (socket) {
                socket.close();
                socket = null;
                //Retry connection in 1 second
                setTimeout(() => {isReconnecting = true; connect(accessTokenStr);}, 1000);
            }
        };
    }

    let lastPingTime = Date.now();

    function ping(){
        //console.log('Ping interval function called');
        if (socket && socket.readyState === WebSocket.OPEN) {
            if(Date.now() - lastPingTime >= 30000){
                lastPingTime = Date.now();

                socket.send(JSON.stringify({ type: 'ping' }));
                console.log('ping');
            }

            requestAnimationFrame(ping);
        }/* else {
            console.log('WebSocket is not open');

            connect(instanceId, accessToken);
        }*/
    }

    if(isProxy){
        connect(accessTokenStr);

        window.connect = function() { connect(accessTokenStr); };
    }else{
        invite_button.style.display = "none";
        panel_container.style.display = "none";
        window.isLeader = true;
        gameManager.triggerJoinGame("isLeader", true);
    }
};

async function ssoFetchData(instanceId: string, accessToken: string, post_data:any = null, first_request:boolean = false) {
    if(first_request && isProxy){
        await fetch('/.proxy/warmerise/logout', { method: 'GET', credentials: 'include' }).then(response => response.text()).catch(() => {});
    }

    const url:string = (isProxy ? '/.proxy' : 'https://warmerise.com') + `/sso/discord?access_data=${btoa(accessToken)}` + '&json_only&source=game';

    const onSuccess = function(data:any){
        console.log("SSO Success", JSON.stringify(data));
        if(data.status > 0){
            sso_buttons_wrapper.removeAttribute("style");
            sso_buttons_wrapper.innerHTML = '<style>.sso-buttons-wrapper { width:600px;max-width:90%; }</style>';

            /*if(sso_buttons_wrapper){
                sso_buttons_wrapper.innerHTML = '<style>.sso-buttons-wrapper { width:600px;max-width:90%; }</style><iframe src="' + url + '&format=smoothbox' + '" style="width:100%;height:100%;"></iframe>';
            }*/

            if("username" in data.data){
                let headingText = document.createElement("h2");
                headingText.innerText = "Welcome back, " + data.data.username;
                sso_buttons_wrapper.appendChild(headingText);
            
                let messageElement = document.createElement("p");
                if(data.status === 1){
                    messageElement.innerHTML = 'You are linking your Discord account to the current logged in Warmerise account: <a target=\'_blank\' href=\'https://warmerise.com/profile/' + data.data.username + '\' target=\'_blank\'>' + data.data.username + '</a>' + (data.data.linked_username ? '<br>We\'ve also noticed that this Discord account currently links to another Warmerise account, if you wish to log in with that account instead, please <a href=\'/logout\'>Sign Out</a> on-site and launch the game again (You won\'t be able to link the previous account back if you click Continue): <a target=\'_blank\' href=\'https://warmerise.com/profile/' + data.data.linked_username + '\' target=\'_blank\'>' + data.data.linked_username + '</a>' : '');
                    sso_buttons_wrapper.appendChild(messageElement);
                    /*const passwordElement = document.createElement("input");
                    passwordElement.type = "password";
                    passwordElement.placeholder = "Your Warmerise password is required to continue...";
                    passwordElement.style.cssText = 'padding: 10px 15px; width: 350px; max-width: 100%; box-sizing: border-box;margin-bottom: 1em;';
                    sso_buttons_wrapper.appendChild(passwordElement);*/
                }else if(data.status === 2){
                    messageElement.innerHTML = 'Your Discord email address ' + data.data.email + ' matches the profile: <a target=\'_blank\' href=\'https://warmerise.com/profile/' + data.data.username + '\' target=\'_blank\'>' + data.data.username + '</a>';
                    sso_buttons_wrapper.appendChild(messageElement);
                }

                let continueButton = document.createElement('a');
                continueButton.className = 'sso-button discord-color';
                continueButton.innerHTML = '<span>Continue Login as ' + data.data.username + '</span>';
                continueButton.onclick = function(){
                    ssoFetchData(instanceId, accessToken, { password: "123", continue: "1" });
                };
                sso_buttons_wrapper.appendChild(continueButton);
                if(!isProxy){
                    if(data.status === 1){
                        const additionalMessage = document.createElement("p");
                        additionalMessage.innerHTML = '<b>Wrong Account?</b> If you wish to link your Discord to a different account, please sign out <a href="https://warmerise.com/logout?return_url=64-' + btoa(document.referrer || window.location.href) + '">here</a> and relogin, then try launching the game again.';
                        sso_buttons_wrapper.appendChild(additionalMessage);
                    }else if(data.status === 2){
                        const additionalMessage = document.createElement("p");
                        additionalMessage.innerHTML = '<b>Wrong Account?</b> If you wish to link your Discord to a different account, please login to that account <a href="https://warmerise.com/login/return_url/64-' + btoa(document.referrer || window.location.href) + '"> here</a> and then try again.';
                        sso_buttons_wrapper.appendChild(additionalMessage);
                    }
                }else{
                    if(data.status === 2){
                        const additionalMessage = document.createElement("p");
                        additionalMessage.innerHTML = '<b>Wrong Account?</b> You can relink an account to your Discord User by visiting the Settings > SSO section of Warmerise.com.';
                        sso_buttons_wrapper.appendChild(additionalMessage);
                    }

                    setTimeout(function(){
                        document.querySelectorAll<HTMLAnchorElement>("#sso_buttons_wrapper a").forEach(link => {
                            const href = link.getAttribute("href");
                            if (href && href.trim() !== "") {
                                link.href = "";
                                link.onclick = function(){
                                    discordSdk.commands.openExternalLink({
                                        url: href
                                    });
                                }
                            }
                        });
                    }, 1);
                }
            }
        }else{
            continueJoinSession(instanceId, accessToken);
        }
    };

    const onError = function(error:any){ 
        //console.error("SSO Error:", error);
        if(sso_buttons_wrapper){
            sso_buttons_wrapper.innerHTML = "Error: " + error;
        }
    };

    try {
        const options:any = {
            method: post_data ? 'POST' : 'GET',
            credentials: 'include',
            headers: post_data ? { 'Content-Type': 'application/x-www-form-urlencoded' } : {},
            body: post_data ? new URLSearchParams(post_data).toString() : undefined
        };
    
        const response = await fetch(url, options);
    
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const data = await response.json(); // Parse response as JSON
        onSuccess(data); // Call success callback
    } catch (error) {
        onError(error); // Call error callback
    }
}

export function enableInviteButton(){
    if(!invitePermissionEnabled) return;
    invite_section.removeAttribute('style');
}

export function disableInviteButtonMessage(){
    invite_message.style.display = "none";
    gameManager.setInviteOpened(true);
}

export function openGameModeSelection(source:string){
    console.log("openGameModeSelection: " + source);
    
    gamemode_panel_container.style.display = "block";
    const gameModeClick = (event:MouseEvent) => {
        if(!event.currentTarget) return;
        const target = event.currentTarget as HTMLElement;
        if(!target.dataset.gamemodedata) return;
        const custom_asset:Warmerise_Custom_Assets = JSON.parse(target.dataset.gamemodedata) as Warmerise_Custom_Assets;
        const asset_file:Warmerise_Custom_Asset_Files | null = custom_asset.release_channel?.asset_file || null;
        if(asset_file){
            //Send the game mode data to the game
            sendMessageToChild({"type":"gamemode-command", "data_url": asset_file.hash_reference });
        }
    };
    
    // Function to populate game modes
    const populateGameModes = (searchTerm: string = "") => {
        gamemode_grid.innerHTML = "";
        getModeList(true, 0, searchTerm).then((assets) => {
            for(let i = 0; i < assets.length; i++){
                let div = document.createElement("div");
                div.dataset.gamemodedata = JSON.stringify(assets[i]);
                div.className = "player ready gamemode-item";
                
                // Get thumbnail URL from the release channel asset file
                const thumbnailPath = assets[i].release_channel?.asset_file?.thumbnail_path || '';
                const thumbnailUrl = thumbnailPath ? `https://assets.warmerise.com/${thumbnailPath}` : '';
                const thumbnailHtml = thumbnailUrl 
                    ? `<img src="${thumbnailUrl}" class="gamemode-thumbnail" alt="${assets[i].asset_name}" onerror="this.style.display='none'">` 
                    : '<div class="gamemode-thumbnail-placeholder"></div>';
                
                div.innerHTML = 
                    '<div class="gamemode-content">' +
                        thumbnailHtml +
                        '<div class="status-container">' +
                            '<span class="player-name">' + assets[i].asset_name + '</span>' +
                            '<span class="status">' + assets[i].asset_description + '</span>' +
                        '</div>' +
                    '</div>';
                div.onclick = gameModeClick;
                gamemode_grid.appendChild(div);
            }
        }).catch((error) => {
            console.error("Failed to load game modes:", error);
            gamemode_grid.innerHTML = '<div style="text-align: center; padding: 20px;">Failed to load game modes</div>';
        });
    };
    
    // Initial load
    populateGameModes();
    
    // Set up search functionality
    const searchInput = document.getElementById("gameModeSearch") as HTMLInputElement;
    if (searchInput) {
        let searchTimeout: NodeJS.Timeout;
        
        searchInput.value = ""; // Reset search on open
        
        searchInput.addEventListener("input", (event) => {
            const target = event.target as HTMLInputElement;
            const searchTerm = target.value.trim();
            
            // Clear previous timeout
            clearTimeout(searchTimeout);
            
            // Debounce the search to avoid too many API calls
            searchTimeout = setTimeout(() => {
                populateGameModes(searchTerm);
            }, 300);
        });
    }
}

export function beginCountdown(shareLink: string, baseIframeUrl: string, isLeader: boolean) {
    const params = new URLSearchParams(shareLink);
    /*const gm = params.get("gm");
    const m = params.get("m");*/
    const p = params.get("p");

    if(typeof p !== "undefined" && p !== null){
        shareLinkTmp = shareLink;
        baseIframeUrlTmp = baseIframeUrl;
        /*room_capacity = p;
        //updatePlayerCountLabel();
        map_name.innerHTML = "&nbsp;- " + m;
        game_mode.innerHTML = "&nbsp;- " + gm;
        more_info.textContent = gm + " >> " + m;*/
    }

    if(!isLeader){
        stopCountdownTimer();
        gameManager.applyInviteLink(shareLink + "%%apply%%", baseIframeUrl); //Pre-send the invite link to ungray the in-game join button
        if(isReady){
            let timer = 10;
            countdown_timer = setInterval(function(){
                if(gameManager.isGameFrameLoaded()){
                    timer--;
                }
                
                const timerText = '00:' + String(timer).padStart(2, '0');
                //countdown.innerHTML = '&nbsp;' + timerText;
                info_timer.textContent = timerText;
                if(timer <= 0){
                    if(!invitePermissionEnabled){
                        invite_button.style.display = "none";
                    }
                    gameManager.applyInviteLink(shareLink, baseIframeUrl);
                    stopCountdownTimer();
                    shareLinkTmp = "";
                    baseIframeUrlTmp = "";
                    disableInviteButtonMessage();
                }
            }, 1000);
        }
    }else{
        shareLinkTmp = "";
        baseIframeUrlTmp = "";
    }
}

function stopCountdownTimer(){
    if(countdown_timer !== null){
        clearInterval(countdown_timer);
        countdown_timer = null;
        countdown.textContent = info_timer.textContent = '';
    }
}

function socketMessageHandler(event:any):void {
    console.log('Received raw event:', event.data);
    const data = JSON.parse(event.data);
    console.log('Received event:', data);

    switch(data.type) {
        case 'welcome':
            handleWelcomeMessage(data as WelcomeMessage);
            break;
        case 'new-leader':
            handleNewLeaderMessage(data as NewLeaderMessage);
            break;
        case 'user-join':
            handleNewJoinMessage(data as UserJoinMessage);
            break;
        case 'user-leave':
            handleUserLeaveMessage(data as UserLeaveMessage);
            break;
        case 'share-link':
            handleShareLinkMessage(data as ShareLinkMessage);
            break;
        case 'ready-status':
            handleReadyStatusMessage(data as ReadyStatusMessage);
            break;
        case 'join-left-room':
            handleJoinLeftRoomMessage(data as JoinLeftRoomMessage);
            break;
    }
};

function handleReadyStatusMessage(message:ReadyStatusMessage){
    /*const readyStatus:HTMLElement = document.querySelector("#user_" + message.userid + " .status") as HTMLElement;
    if(readyStatus){
        readyStatus.textContent = message.isready ? "READY" : "NOT READY";
        
    }*/
    var userIndex = activityInstance.users.findIndex(x=>x.id == message.userid);
    if(userIndex>=0) {
        activityInstance.users[userIndex].isready = message.isready;
        renderUsers();
    }

    if(myParticipantId === message.userid){
        isReady = message.isready;
        unready_button.textContent = isReady ? "UNREADY" : "READY";
    }

    if(!message.isready){
        stopCountdownTimer();
    }else{
        if(shareLinkTmp !== ""){
            beginCountdown(shareLinkTmp, baseIframeUrlTmp, false);
        }
    }
}

function handleUserLeaveMessage(message:UserLeaveMessage) {
    var userIndex = activityInstance.users.findIndex(x=>x.id == message.participantId);
    if(userIndex>=0) {
        var p = activityInstance.users.splice(userIndex,1);
        console.log("User left: "+p[0].username);
        addMessage(p[0].username, p[0].id, 2, '');
    } else {
        console.log("Could not find user: "+message.participantId);
    }
    /*const userElement:HTMLElement = document.getElementById("user_" + message.participantId) as HTMLElement;
    if(userElement){
        let usrnm:string | null | undefined = userElement.querySelector(".player-name")?.textContent;
        if(typeof usrnm === 'undefined' || !usrnm){
            usrnm = '';
        }
        addMessage(usrnm, message.participantId, 2, '');
        userElement.remove();
        updatePlayerCountLabel();
    }*/
    renderUsers();
}

function handleWelcomeMessage(message:WelcomeMessage) {
    if(message.instanceId === ""){
        if(socket){
            socket.onclose = function(){ 
                invite_button.style.display = "none";
                panel_container.style.display = "none";
                window.isLeader = true;
                gameManager.triggerJoinGame("isLeader", true);
            };
            if(socket.readyState === WebSocket.OPEN){
                socket.close();
            }
        }
        return;
    }

    currentInstanceId = message.instanceId;
    myParticipantId = message.yourParticipantId;
    if(!isReconnecting || !activityInstance){
        activityInstance = new ActivityInstance(message.instanceId, message.password, message.shareLink); 
    }
    if(panel_container){
        panel_container.removeAttribute("style");
    }
    player_grid.innerHTML = '';
    if(message.users) {
        message.users.forEach(user => { 
            activityInstance.addParticipant(new Participant(user.id, user.username, user.avatar, user.isready, user.room, user.region, user.map, user.mode, user.isJoining));
        });
        activityInstance.setLeader(message.leaderParticipantId);
    }
    activityInstance.leaderid = message.leaderParticipantId;
    activityInstance.isprivate = message.isprivate;
    is_private.checked = message.isprivate;

    window.isLeader = message.leaderParticipantId === message.yourParticipantId;
    if(window.isLeader){
        more_info.textContent = leaderInfoMessage;
        unready_button.style.display = "none";
        private_squad_setting.style.display = "block";
    }else{
        if(!invitePermissionEnabled){
            invite_section.removeAttribute('style');
        }
    }

    if(message.shareLink.indexOf('?join') >= 0){
        more_info.style.display = 'none';
    }

    if(isReconnecting){
        isReconnecting = false;
        return;
    }

    gameManager.triggerJoinGame(window.isLeader ? "" : message.shareLink, window.isLeader);
}

function renderUsers(){
    player_grid.innerHTML = '';
    let sections:any = {};
    activityInstance.users.forEach(user => { 
        const inRoom:boolean = user.map !== '' && user.mode !== '' && user.region !== '';
        const section_key:string = inRoom ? user.map + " - " + user.mode + " - " + user.room + " - " + user.region : (!user.isready ? "Getting Ready" : "Main Menu");
        if(!(section_key in sections)){
            sections[section_key] = document.createElement("div");
            sections[section_key].className = "player-section";
            sections[section_key].dataset.title = section_key;
            player_grid.appendChild(sections[section_key]);
        }
        addUser(user.id, user.username, user.avatar, user.id === activityInstance.leaderid, user.isJoining === "3" ? "Joining..." : (!inRoom ? (user.isready ? "Ready" : "Not Ready") : ""), sections[section_key]);
    });
    updatePlayerCountLabel();
}

function addUser(userid:string, username:string, avatar:string | null, isLeader:boolean, isReady:string, parentElement:HTMLElement){
    if(document.getElementById("user_" + userid) !== null) return;
    
    const playerElement:HTMLElement = document.createElement("div");
    playerElement.className = "player";
    playerElement.id = "user_" + userid;
    const avatarElement:HTMLElement = document.createElement("div");
    avatarElement.className = "avatar";
    avatarElement.style.backgroundImage = "url('" + (avatar ? `https://cdn.discordapp.com/avatars/${userid}/${avatar}.webp?size=64` : 'data:image/jpeg;base64,UklGRj4BAABXRUJQVlA4IDIBAACQCACdASpAAEAAPpE8nEiloyMhLhko4LASCWcA0QssGGCaGUk0vdWE+W9CcJm4P9t5nNlZp4jMyEgjsf2Buywvwruwgp2/TBhKuoGoAAD+xO/KvV6MrWkQ5jmJ8bvalibFGk5T+V8vi2jUWSfbMNckg5Hf+SUCF787x4BxuDnKMKqwP67LrIMnXH9/RjOR+cmiZhH8Mml3x1QTHBBSahNYa7za4FjdY98dN6oOSeYsD3vF/xSxltpuk+Xr5YxYgI9j82u7QIJxphz7cIzgMHl5K/jNNbXyKGvmlcblw6Duv3rZpchM2vqgpEjxDsTYqiP7D8ChU6RcppnwMU2WPspH99vmtm4bHN+25PBF/4/29L01ZAA/tKEd40NwBypP74sTfZQQyOpO24xUa35nNuAAAAA=') + "')";
    playerElement.appendChild(avatarElement);
    const infoElement:HTMLElement = document.createElement("div");
    infoElement.className = "status-container";
    const playerNameElement:HTMLElement = document.createElement("div");
    playerNameElement.className = "player-name";
    playerNameElement.textContent = username;
    if(isLeader){
        playerNameElement.style.color = "#e8b126";
    }
    const statusElement:HTMLElement = document.createElement("div");
    statusElement.className = "status";
    statusElement.innerHTML = '<span>' + (isReady === "" ? '&nbsp;' : isReady) + '</span>' + (isLeader ? '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAFBhaW50Lk5FVCA1LjEuMvu8A7YAAAC2ZVhJZklJKgAIAAAABQAaAQUAAQAAAEoAAAAbAQUAAQAAAFIAAAAoAQMAAQAAAAIAAAAxAQIAEAAAAFoAAABphwQAAQAAAGoAAAAAAAAAYAAAAAEAAABgAAAAAQAAAFBhaW50Lk5FVCA1LjEuMgADAACQBwAEAAAAMDIzMAGgAwABAAAAAQAAAAWgBAABAAAAlAAAAAAAAAACAAEAAgAEAAAAUjk4AAIABwAEAAAAMDEwMAAAAADp1fY4ytpsegAAASJJREFUKFNNj0tKA0EYhGv+TuaVh3HlOpqcw0dIfIAiuHThBdy78BpeQ9AIkkQE7zEBj5A4mYRMJ3H8qyHgD9VdVH38TXvpoF18vo9h88IvlbGCzlpP9bzLfuDZzkULMuonzvih2JWFT5AQPTN2ZMQTBMN+knfODxBGkisQUPTM2JGR3mUbIgg1WJ4QjmVJ0TNjR6ZkjBfZHPADRMPXZN69asd8Xv1CDCraRcpArP1dxFWzsEtUWNw9TueUgzRznTIyehtnx6f7iGsm06K61yic6JmxI+M93wObNdKz61bta/SN7GdT59PVHZMe9ZoYvIxnpoS6MKTRID3sNh1A0TNjR8Zt3I5unuhnGvQf/WSq0C79zRPgNm6Hxe3DdEL9hwDgD2lIjhjakL+2AAAAAElFTkSuQmCC" style="float:right;margin-top: 1.25px;">' : '');
    infoElement.appendChild(playerNameElement);
    infoElement.appendChild(statusElement);
    playerElement.appendChild(infoElement);

    //player_grid.appendChild(playerElement);
    parentElement.appendChild(playerElement);

    if(isLeader){
        setLeaderName(username);
    }
}

let messageTimeout:any;
function addMessage(name:string, userid:string, type:number, otherInfo:string){
    const isLeader:boolean = activityInstance.leaderid === userid;
    activityMessages.style.opacity = "1";

    let message:string = name;
    if(isLeader){
        message += " (leader)";
    }
    switch(type){
        case 0:
            message += " is the new activity leader."
            break;
        case 1:
            message += " has joined the activity."
            break;
        case 2:
            message += " has left the activity."
            break;
        case 3:
            message += " has joined the room " + otherInfo + "."
            break;
        case 4:
            message += " has left the room " + otherInfo + "."
            break;
    }

    activityMessages.innerHTML = '<span>' + message + '</span>';

    //Remove the message after 10 seconds
    if(messageTimeout !== null){
        clearTimeout(messageTimeout);
    }
    messageTimeout = setTimeout(function(){
        //messageElement.remove();
        activityMessages.style.opacity = "0";
        messageTimeout = true;
    }, 10000);
}

function handleShareLinkMessage(shareLinkMessage:ShareLinkMessage) {   
    const isLeader:boolean = activityInstance.leader.id === myParticipantId;
    gameManager.triggerJoinGame(shareLinkMessage.shareLink, isLeader);

    if(shareLinkMessage.shareLink.indexOf('?join') >= 0){
        more_info.style.display = 'none';
    }
    
    //Don't trigger join game if we are the leader. 
    if(!isLeader) {
        console.log("handleShareLinkMessage: " + shareLinkMessage.shareLink);
        //Otherwise cause game manager to join the game since we aren't activity leader.
    }else{
        console.log("handleShareLinkMessage: Participant is a leader (leader: " + activityInstance.leader.id + ") (participant: " + myParticipantId + ")");

        if(more_info.textContent === userInfoMessage){
            more_info.textContent = leaderInfoMessage;
        }
    }
}

function handleJoinLeftRoomMessage(joinLeftRoomMessage:JoinLeftRoomMessage){
    activityInstance.users.forEach(user => { 
        if(user.id === joinLeftRoomMessage.userid){
            user.room = joinLeftRoomMessage.roomName;
            user.region = joinLeftRoomMessage.region;
            user.map = joinLeftRoomMessage.map;
            user.mode = joinLeftRoomMessage.mode;
            user.isJoining = joinLeftRoomMessage.left;
        }
    });
    renderUsers();
    if(joinLeftRoomMessage.left === "0" || joinLeftRoomMessage.left === "1"){
        addMessage(joinLeftRoomMessage.username, joinLeftRoomMessage.userid, joinLeftRoomMessage.left === "1" ? 4 : 3, joinLeftRoomMessage.roomName);
    }
    if(myParticipantId === joinLeftRoomMessage.userid){
        if(joinLeftRoomMessage.left === "1"){
            invite_button.removeAttribute("style");
        }else{
            invite_button.style.display = "none"; 
        }
    }
    if((joinLeftRoomMessage.left === "1" && activityInstance.leaderid !== myParticipantId) || !isReady){
        unready_button.removeAttribute("style");
    }else{
        unready_button.style.display = "none";
    }
}

function handleNewJoinMessage(message: UserJoinMessage) {
    activityInstance.addParticipant(new Participant(message.userid, message.username, message.avatar, message.isready, message.room, message.region, message.map, message.mode, message.isJoining));
    if(message.userid === myParticipantId){
        myParticipantName = message.username;
    }
    if(!activityInstance.leader){
        activityInstance.setLeader(activityInstance.leaderid);
    }
    renderUsers();
    //addUser(message.userid, message.username, message.avatar, message.userid === activityInstance.leaderid, message.isready);
    //updatePlayerCountLabel();
    sendMessageToChild(message);
    addMessage(message.username, message.userid, 1, '');
}

function updatePlayerCountLabel(){
    //if(room_capacity !== ""){
    player_count.innerHTML = "&nbsp;(" + activityInstance.users.length + ")"/* + "/" + room_capacity*/;
    //}
}

function setLeaderName(username:string){
    leader_name.textContent = username + "'s Squad";
}

function handleNewLeaderMessage(message: NewLeaderMessage) {
    var oldLeader = activityInstance.getLeader();
    activityInstance.leaderid = message.newLeaderParticipantId;
    var leader = activityInstance.setLeader(message.newLeaderParticipantId);
    if(leader) {
        console.log(`New leader is ${leader.username}`);
        if(oldLeader) console.log(`replacing old leader: ${oldLeader.username}`);

        setLeaderName(leader.username);
        window.isLeader = message.newLeaderParticipantId === myParticipantId;
        if(window.isLeader){
            gameManager.triggerJoinGame("isLeader", true);
            unready_button.style.display = "none";
            private_squad_setting.style.display = "block";
            is_private.checked = message.isprivate;
            more_info.textContent = leaderInfoMessage;
        }

        addMessage(leader.username, leader.id, 0, '');

        renderUsers();
    } else {
        console.log(`Error - new leader: ${message.newLeaderParticipantId} not found`);
    }

    sendMessageToChild(message);
    // Add additional logic to handle the new leader event if necessary
};



//Destroy socket if window closed.
window.addEventListener('beforeunload', () => {
    if (socket) {
        socket.close();
    }
});
